module.exports = __webpack_public_path__ + "static/media/search-grey.714f2961.svg";